<template>
  <base-setting-widget ref="base" :iteminfo="iteminfo" v-bind="$attrs" v-on="$listeners"
                       style="position: relative">
    <div class="">
      <div class="flex a-center">
        <div class="flex a-center">组件标题:
          <div>
            <Input class="m-l-10" placeholder="组件标题" v-model="iteminfo.config.menutitle"/>
          </div>
        </div>
        <div class="block">
          <!--          <div class="flex a-center">-->
          <!--            <div class="border p-l-5" style="width: 80px;height: 30px;line-height: 30px">-->
          <!--              {{ iteminfo.config.titleColor }}-->
          <!--            </div>-->
          <!--            <div class="block">-->
          <!--              <ColorPicker class="m-l-10 ld-color-pick" recommend-->
          <!--                           v-model="iteminfo.config.titleColor"/>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
      </div>


      <div class=" m-t-10 flex a-center">
        <div class="m-r-10">标题颜色:</div>
        <div class="flex a-center">
          <div class="border p-l-5" style="width: 80px;height: 30px;line-height: 30px">
            {{ iteminfo.config.titleColor }}
          </div>
          <ColorPicker class="m-l-10 ld-color-pick" recommend
                       v-model="iteminfo.config.titleColor"/>
        </div>
      </div>

      <div class="m-t-10">商品链接:</div>
      <div class="m-t-10">
        <tooltip style="width: 100%"
                 :disabled="!iteminfo.config.jumpObj.linkUrl"
                 max-width="250">

          <Input placeholder="商品链接"
                 clearable readonly
                 id="input-product" v-model="iteminfo.config.jumpObj.linkUrl">
          <span slot="append" class="icon-link" style="cursor: pointer"
                @click="showMaterialModal()"></span>
          </Input>
          <div slot="content" style="white-space: normal;">
            {{ iteminfo.config.jumpObj.linkUrl }}
          </div>
        </tooltip>
      </div>
    </div>
    <div class="flex a-center m-t-10">
      商品价格：
      <RadioGroup v-model="iteminfo.config.showPrice">
        <Radio class="m-l-5" :label="1">
          显示
        </Radio>
        <Radio class="m-l-10" :label="0">
          隐藏
        </Radio>
      </RadioGroup>
    </div>
    <div class="flex a-center m-t-10">
      显示行数：
      <RadioGroup v-model="iteminfo.config.haslimit">
        <Radio class="m-l-5" :label="1">
          有限
        </Radio>
        <Radio class="m-l-10" :label="0">
          无限
        </Radio>
      </RadioGroup>
    </div>
    <!--<div class="flex a-center m-t-10">-->
    <!--显示个数：-->
    <!--<RadioGroup v-model="iteminfo.config.shownum">-->
    <!--<Radio :label="1">-->
    <!--无限-->
    <!--</Radio>-->
    <!--<Radio :label="2">-->
    <!--有限-->
    <!--</Radio>-->
    <!--</RadioGroup>-->
    <!--<input-number class="flex-1" v-if="iteminfo.config.shownum === 2"></input-number>-->
    <!--</div>-->
    <div class="bg-white p-5" style="min-height: 80px" v-if="iteminfo.config.displayType === 2">
      <ul class="p-b-50">
        <li :key="index" v-for="(item,index) in getshowDataList">
          <img :src="getItemPic(item)"
               class="w-full"
               style="cursor: pointer;vertical-align: top"/>
        </li>
      </ul>
    </div>
    <div class="bg-white" style="min-height: 72px" v-if="iteminfo.config.displayType === 3">
      <ul class="flex j-start flex-wrap m-t-10 p-b-50" style="margin-left: -5px;margin-right: -5px">
        <li :key="index" class="p-4 flex a-center flex-s-0" style="width: 50%"
            :style="{width:getItemWidth(index)}"
            v-for="(item,index) in getshowDataList">
          <ratio-div :RadioValue="75">
            <div class="w-full h-full absolute top-0 left-0 flex a-center j-center o-hidden">
              <img :src="getTwoItemPic(item)"
                   class="w-full"
                   style="cursor: pointer;min-height: 100%"/>
            </div>
          </ratio-div>

          <div
            v-if="hasDeleteButton(index)"
            class="flex j-center"
            :style="{minWidth:delButtonWidth+'px',visibility:iteminfo.config.haslimit === 1?'visible':'hidden'}">

            <i @click.stop="delRow(index)" class="icon-delete_facet fs-18"
               style="cursor: pointer;color: #F44336"/>

          </div>
        </li>
      </ul>
    </div>
    <div class="bg-white" style="min-height: 60px" v-if="iteminfo.config.displayType === 1">
      <ul class="m-t-10 p-b-50" style="margin-left: -5px;margin-right: -5px">
        <li :key="index" class="p-5" v-for="(item,index) in getshowDataList">

          <div class="flex a-center">
            <img :src="getdefaultListProductImg(item)" alt="" class="v-a-top"
                 :style="{width:getItemWidth(index)}"
                 v-if="!item.imgUrl">
            <div
              v-if="hasDeleteButton(index) && !item.imgUrl"
              class="flex j-end"
              :style="{minWidth:delButtonWidth+'px',visibility:iteminfo.config.haslimit === 1?'visible':'hidden'}">
              <i @click.stop="delRow(index)" class="icon-delete_facet fs-18"
                 style="cursor: pointer;color: #F44336"/>

            </div>
          </div>

          <div class="flex a-center" v-if="item.imgUrl">
            <ratio-div :RadioValue="75" class="flex-s-0" style="width: 120px">
              <div class="w-full h-full absolute top-0 left-0 flex a-center j-center o-hidden">
                <img :src="getdefaultListProductImg(item)"
                     class="w-full"
                     style="cursor: pointer;min-height: 100%"/>
              </div>
            </ratio-div>
            <div class="flex-column m-l-10 p-10 flex-1"
                 style="align-items: flex-start;justify-content: space-between;height: 90px;background-color: #F9F9F9">
              <div class="lin2 bold">
                {{ item.name }}
              </div>
              <div class="">
                <span v-if="iteminfo.config.showPrice" class="bold"
                      style="color: #F44336">{{ item.price }}</span>
              </div>
            </div>

            <div
              v-if="hasDeleteButton(index)"
              class="flex j-end"
              :style="{minWidth:delButtonWidth+'px',visibility:iteminfo.config.haslimit === 1?'visible':'hidden'}">

              <i @click.stop="delRow(index)" class="icon-delete_facet fs-18"
                 style="cursor: pointer;color: #F44336"/>

            </div>

          </div>

        </li>
      </ul>
    </div>
    <div class="bg-white m-t-10 p-b-50"
         style="min-height: 60px;margin-left: -5px;margin-right: -5px"
         v-if="iteminfo.config.displayType === 4">
      <waterfall :col='col' :data="getshowDataList" ref="waterfall">
        <template v-for="(item,index) in getshowDataList">
          <div :key="index" class="m-5">
            <img :src="getdefaultWaterListImg(item,index)" alt="加载错误" class="w-full"/>
          </div>
        </template>
      </waterfall>
    </div>
    <div class="m-t-10" v-if="iteminfo.config.displayType === 5">
      <ul>
        <li :key="index" class="m-b-10" style="background-color: #F2F2F2;min-height: 90px"
            v-for="(item,index) in iteminfo.config.datalist">
          <div class="flex c-center p-v-10 p-l-10">
            <div class="flex a-center j-center o-hidden" style="width: 110px;height: 90px">
              <img :src="getItemPic(item)" alt="" class="w-full" style="min-height: 100%">
            </div>
            <div class="flex-1 flex-column p-l-10" style="height: 90px;align-items: flex-start">
              <div class="lin2 bold">
                根先生含氨基酸水溶肥根先生含氨基酸水溶肥
                <!--{{item.title}}-->
              </div>
              <div class="m-t-15">
                <span class="bold" style="color: #F44336">￥123.00</span>
              </div>
            </div>
            <div class="flex-column a-center flex-s-0"
                 style="width: 50px;justify-content: space-around;">
              <i :style="{color:getUpColor(index)}" @click.stop="onUpClick(index)"
                 class="icon-up fs-18"
                 style="cursor: pointer;"/>
              <i :style="{color:getDownColor(index,iteminfo.config.datalist.length)}"
                 @click.stop="onDownClick(index)"
                 class="icon-down fs-18"
                 style="cursor: pointer;"/>
              <i @click.stop="onDelClick(index)" class="icon-delete_facet fs-18"
                 style="cursor: pointer;color: #666666"/>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="p-b-20"
         style="position: absolute;bottom: 0;left: 20px;width:calc(100% - 40px);z-index: 999;background-color: white">
      <div v-if="iteminfo.config.displayType !== 4 && iteminfo.config.haslimit === 1"
           @click="onItemAddClick"
           class="flex a-center j-center"
           style="height: 48px;border:1px dashed #D8D8D8;cursor: pointer;background-color: #F2F2F2;">
        <Icon size="24" type="ios-add"/>
        <div class="m-l-2">添加行数</div>
      </div>
    </div>
    <div v-if="iteminfo.config.displayType === 4  && iteminfo.config.haslimit === 1" class="flex">
      <div class="p-b-20 flex"
           style="position: absolute;bottom: 0;left: 20px;width:calc(100% - 40px);z-index: 999;background-color: white">
        <div @click="onItemDelClick" class="flex a-center j-center"
             style="width:50%;height: 48px;border:1px dashed #D8D8D8;cursor: pointer;background-color: #F2F2F2">
          <Icon size="24" type="ios-remove"/>
          <span class="m-l-2">删除</span>
        </div>
        <div @click="onItemAddClick" class="flex a-center j-center"
             style="width:50%;height: 48px;border:1px dashed #D8D8D8;cursor: pointer;background-color: #F2F2F2">
          <Icon size="24" type="ios-add"/>
          <span class="m-l-2">添加</span>
        </div>
      </div>
    </div>

    <material-choice-widget
      title="选择链接"
      :pages="choosePage()"
      :on-ok="materialChoiceOk"
      ref="materialChoiceWidget"/>
  </base-setting-widget>
</template>

<script>
import BaseSettingWidget from '../base/BaseSettingWidget'
import RatioDiv from '../../common/RatioDiv'
import MaterialChoiceWidget from '@/components/common/chiose/MaterialChoiceWidget'
import {mapActions} from 'vuex'
import {parseUrl} from '@/utils/UrlFormat'
import {getPages} from '@/components/common/chiose/MaterailChoiceWidgetUtil'

export default {
  name: 'ProductSettingWidget',
  components: {RatioDiv, BaseSettingWidget, MaterialChoiceWidget},
  props: {
    iteminfo: Object
  },
  data () {
    return {
      show: 1,
      col: 2,
      modalInfo: {
        totalPage: 99,
        pageSize: 20,
        pageNum: 1,
        modalShowHide: false,
        columns: [
          {
            type: 'selection',
            width: 55,
            align: 'center',
          },
          {
            title: '商品图',
            slot: 'imageUrl',
            width: 100,
          },
          {
            title: '商品名称',
            key: 'name',
            minWidth: 250,
          },
          {
            title: '规格',
            key: 'spec',
            width: 100,
          },
          {
            title: '价格',
            key: 'price',
            width: 100,
          },
          {
            title: '链接',
            key: 'url',
            minWidth: 250,
          },
          {
            title: '复制',
            slot: 'link',
            width: 80,
            align: 'center'
          },
        ],
        datas: [
          {
            name: 'name1',
            spec: '200ml',
            price: '20',
            url: 'www.baidu.com',
          },
          {
            name: 'name2',
            spec: '200ml',
            price: '20',
            url: 'www.baidu.com',
          },
          {
            name: 'name3',
            spec: '200ml',
            price: '20',
            url: 'www.baidu.com',
          },
        ]
      },
      // 删除按钮宽度
      delButtonWidth: 30

    }
  },
  watch: {
    // 'iteminfo.config.jumpObj.linkUrl': {
    //   handler (newValue) {
    //     this.getDataShow()
    //   },
    //   deep: true,
    //   immediate: true
    // }
  },
  computed: {
    getshowDataList () {
      let list = []
      list = this.getDefaultProductList()
      return list
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      console.log('produtSettingWidget init')
    },
    /**
     * 弹框 下拉框只显示商品page
     */
    choosePage () {
      return getPages([8])
    },
    getItemPic (item) {
      let src = require('../../../assets/tempmenu/img_product_abreast.png')
      if (this.iteminfo.config.displayType === 1) {
        src = require('../../../assets/tempmenu/img_product_abreast.png')
      }
      if (item.imgUrl) {
        src = item.imgUrl
      }
      return src
    },
    onItemAddClick () {
      if (this.iteminfo.config.displayType === 3) {
        this.iteminfo.config.datalist.push({
          id: 0,
          name: '',
          imgUrl: '',
          price: '',
          unit: '',
        })
        this.iteminfo.config.datalist.push({
          id: 0,
          name: '',
          imgUrl: '',
          price: '',
          unit: '',
        })
      } else {
        this.iteminfo.config.datalist.push({
          id: 0,
          name: '',
          imgUrl: '',
          price: '',
          unit: '',
        })
      }

      this.calcShowNum()

      if (this.iteminfo.config.displayType === 4) {
        //瀑布流需要刷新..
        // setTimeout(()=>{
        //   this.$nextTick(() => {
        //     if (this.$refs.base && this.$refs.base.$refs.scrollDiv) {
        //       let scrollHeight = this.$refs.base.$refs.scrollDiv.scrollHeight
        //       this.$refs.base.$refs.scrollDiv.scrollTo({top: scrollHeight, behavior: 'smooth'})
        //       console.log('wtf scroll')
        //     }
        //   })
        // },1000)

      } else {
        this.$nextTick(() => {
          if (this.$refs.base && this.$refs.base.$refs.scrollDiv) {
            let scrollHeight = this.$refs.base.$refs.scrollDiv.scrollHeight
            this.$refs.base.$refs.scrollDiv.scrollTo({top: scrollHeight, behavior: 'smooth'})
          }
        })
      }
    },

    scroll2Bottom () {
      if (this.$refs.base && this.$refs.base.$refs.scrollDiv) {
        let scrollHeight = this.$refs.base.$refs.scrollDiv.scrollHeight
        this.$refs.base.$refs.scrollDiv.scrollTo({top: scrollHeight, behavior: 'smooth'})
      }
    },

    onItemDelClick () {
      let datalist = this.iteminfo.config.datalist
      if (datalist && datalist.length > 1) {
        datalist.splice(datalist.length - 1, 1)
      }
      this.calcShowNum()
    },

    /**
     * 设置显示行数,瀑布流是个数
     */
    calcShowNum () {
      let len = this.iteminfo.config.datalist.length
      if (this.iteminfo.config.displayType === 1) {                  //列表式显示行数 = length
        this.iteminfo.config.showNum = len
      } else if (this.iteminfo.config.displayType === 3) {           //并列式显示行数 = length/2
        this.iteminfo.config.showNum = Math.ceil(len / 2)
      } else { // 全部显示
        this.iteminfo.config.showNum = len
      }
    },
    onUpClick (index) {
      if (index > 0) {
        let item = this.iteminfo.config.datalist[index - 1]
        this.iteminfo.config.datalist.splice(index - 1, 1)
        this.iteminfo.config.datalist.splice(index, 0, item)
      }
    },
    onDownClick (index) {
      if (index < (this.iteminfo.config.datalist.length - 1)) {
        let item = this.iteminfo.config.datalist[index + 1]
        this.iteminfo.config.datalist.splice(index + 1, 1)
        this.iteminfo.config.datalist.splice(index, 0, item)
      }
    },
    onDelClick (index) {
      this.iteminfo.config.datalist.splice(index, 1)
    },
    getUpColor (index) {
      if (index === 0) {
        return '#BBBBBB'
      } else {
        return '#666666'
      }
    },
    getDownColor (index, length) {
      if (length === 0 || index === length - 1) {
        return '#BBBBBB'
      } else {
        return '#666666'
      }
    },

    getTwoItemPic (item) {
      let src = require('../../../assets/tempmenu/img_product_abreast.png')
      if (item.imgUrl) {
        src = item.imgUrl
      }
      return src
    },
    getdefaultListProductImg (item) {
      let src = require('../../../assets/tempmenu/img_product_list.png')
      if (item.imgUrl) {
        src = item.imgUrl
      }
      return src
    },
    getdefaultWaterListImg (item, index) {
      let src = require('../../../assets/tempmenu/img_product_infinite_scrolling.png')
      if (index % 2 === 0) {
        src = require('../../../assets/tempmenu/img_product_infinite_scrolling2.png')
      }
      if (item.imgUrl) {
        src = item.imgUrl
      }
      return src
    },

    getDefaultProductList () {
      // let templist = []
      // let length = 1
      // if (this.iteminfo.config.displayType === 1) {
      //   length = 1
      // } else if (this.iteminfo.config.displayType === 2) {
      //   length = 2
      // } else if (this.iteminfo.config.displayType === 3) {
      //   length = 2
      // } else if (this.iteminfo.config.displayType === 4) {
      //   length = 4
      // }
      // let len = this.iteminfo.config.datalist.length || 0
      // if (length <= len) {
      //   templist = this.iteminfo.config.datalist
      // } else {
      //   templist = templist.concat(this.iteminfo.config.datalist)
      //   for (let i = 0; i < (length - len); i++) {
      //     templist.push({
      //       id: 0,
      //       name: '',
      //       imgUrl: '',
      //       price: '',
      //       unit: '',
      //     })
      //   }
      // }
      // return templist
      return this.iteminfo.config.datalist
    },
    // ok () {
    //   this.modalInfo.modalShowHide = false
    //   this.$Message.info('确定')
    // },
    // cancel () {
    //   this.modalInfo.modalShowHide = false
    //   this.$Message.info('取消')
    // },

    getItemWidth (index) {
      let displayType = this.iteminfo.config.displayType
      let delButtonWidth = this.delButtonWidth
      if (displayType === 1) {  //单列
        return 'calc(100% - ' + delButtonWidth + 'px)'
      } else if (displayType === 3) {  //双列
        if (index % 2 === 1) {
          return 'calc(50% + ' + delButtonWidth / 2 + 'px)'
        } else {
          return 'calc(50% - ' + delButtonWidth / 2 + 'px)'
        }
      }
    },

    //删除行
    delRow (index) {
      let displayType = this.iteminfo.config.displayType
      let datalist = this.iteminfo.config.datalist
      if (displayType === 1) {
        if (datalist && datalist.length > 1) {
          datalist.splice(index, 1)
        }
      } else if (displayType === 3) {  //双列
        if (datalist && datalist.length > 2) {
          datalist.splice(index - 1, 2)
        }
      }

      this.calcShowNum()
    },

    hasDeleteButton (index) {
      let displayType = this.iteminfo.config.displayType
      if (displayType === 1) {  //单列
        return 1
      } else if (displayType === 3) {  //双列
        if (index % 2 === 1) {
          return 1
        } else {
          return 0
        }
      }
    },

    showMaterialModal () {
      this.$refs.materialChoiceWidget.show()
    },
    materialChoiceOk (data) {
      if (data && data.length > 0) {
        this.iteminfo.config.jumpObj.linkUrl = data[0].url
        this.$nextTick(() => {
          this.checkInputOverflow()
        })
      }
    },

    /**
     * input输入框是否超出
     */
    checkInputOverflow () {
      let input = document.getElementById('input')
      if (input) {
        this.showTooltip = input.clientWidth < input.scrollWidth
      }
    },
    // ok () {
    //   this.$refs.materialChoiceWidget.onOk()
    //   this.$refs.materialChoiceWidget.hide()
    // },
    // cancel () {
    //   this.$refs.materialChoiceWidget.onCancel()
    //   this.$refs.materialChoiceWidget.hide()
    // },
    // getDataShow () {
    //   if (this.iteminfo.config.jumpObj.linkUrl) {
    //     this.getProductLists()
    //   } else {
    //     // this.iteminfo.config.datalist = this.getDefaultProductList()
    //     this.resetDatalist()
    //   }
    // },

    // getProductLists () {
    //   let url = this.iteminfo.config.jumpObj.linkUrl
    //   let par = parseUrl(url)
    //   if (par.contentType && parseInt(par.contentType) === 33 || parseInt(par.contentType) === 32) {
    //     let pageSize = 20
    //     if (this.iteminfo.config.datalist) {
    //       pageSize = this.iteminfo.config.datalist.length
    //     }
    //
    //     let params = {
    //       pageNum: 1,
    //       pageSize: pageSize
    //     }
    //     let strId = par.id.replace(',', '')
    //     let id = parseInt(strId) || 0
    //     switch (parseInt(par.contentType)) {
    //       case 33:
    //         params.categoryId = id
    //         break
    //       case 32:
    //         params.groupId = id
    //         break
    //     }
    //     this.getGoods(params).then(res => {
    //       if (res.code === 0 && res.data && res.data.list && res.data.list.length) {
    //         //重置数据
    //         this.resetDatalist()
    //         let datalist = this.iteminfo.config.datalist
    //         res.data.list.map((child, index) => {
    //           let specification = ''
    //           let unit = ''
    //           let price = ''
    //           if (child.specList && child.specList.length) {
    //             let speinfo = child.specList[0]
    //             let showList = []
    //             if (child.specList && child.specList.length) {
    //               let specType = child.specList[0].specType
    //               if (specType === 1) {
    //                 for (let i = 0; i < speinfo.childList.length; i++) {
    //                   let item = speinfo.childList[i]
    //                   if (item.isDefault !== 1) {
    //                     showList.push(item)
    //                   } else {
    //                     showList.push(item)
    //                     break
    //                   }
    //                 }
    //                 if (showList && showList.length) {
    //                   for (let i = 0; i < showList.length; i++) {
    //                     let item = showList[i]
    //                     if (i === 0) {
    //                       if (showList.length > 1) {
    //                         specification = item.qty + item.unit
    //                       } else if (showList.length === 1) {
    //                         specification = item.qty + item.unit + '/' + item.packageUnit
    //                       }
    //                     } else if (i < showList.length - 1) {
    //                       specification += '*' + item.qty + item.unit
    //                     } else if (i === showList.length - 1) {
    //                       specification += '*' + item.qty + item.unit + '/' + item.packageUnit
    //                     }
    //                   }
    //                   unit = showList[showList.length - 1].packageUnit
    //                   price = showList[showList.length - 1].salePrice
    //                 }
    //               } else if (specType === 2) {
    //                 specification = child.specList[0].childList[0].packageUnit || ''
    //                 price = child.specList[0].childList[0].salePrice || ''
    //               }
    //             }
    //           }
    //           child.specification = specification || ''
    //           child.unit = unit || ''
    //           let priceshow = price ? parseFloat(price) : 0
    //           child.price = priceshow.toFixed(2) || ''
    //           /////////////////////////////////////////////////////////////////////////////////////////////
    //           //需要显示, 就设置datalist item的数据
    //           if (index < datalist.length) {
    //             datalist[index].id = child.id
    //             datalist[index].name = child.name
    //             datalist[index].price = child.price
    //             datalist[index].unit = unit || ''
    //             //背景图
    //             if (child.coverList && child.coverList.length > 0) {
    //               for (let i = 0; i < child.coverList.length; i++) {
    //                 let coverListItem = child.coverList[i]
    //                 if (coverListItem && coverListItem.type === 1 && coverListItem.img) {    //图片类型
    //                   datalist[index].imgUrl = coverListItem.img
    //                   break
    //                 } else if (coverListItem && coverListItem.type === 2 && coverListItem.videoUrl) {//视频类型
    //                   datalist[index].imgUrl = coverListItem.videoUrl + '?x-oss-process=video/snapshot,t_1000,f_png,w_0,h_0'
    //                   break
    //                 }
    //               }
    //             }
    //           }
    //           /////////////////////////////////////////////////////////////////////////////////////////////
    //           return child
    //         })
    //       } else {
    //         this.resetDatalist()
    //       }
    //     })
    //   } else if (par.contentType && parseInt(par.contentType) === 31) {
    //     let strId = par.id.replace(',', '')
    //     let id = parseInt(strId) || 0
    //     if (id) {
    //       this.getGoodDetail(id).then(res => {
    //         if (res.code == 0) {
    //           let data = res.data
    //           let specification = ''
    //           let unit = ''
    //           let price = ''
    //           if (data.specList && data.specList.length) {
    //             let speinfo = data.specList[0]
    //             let showList = []
    //             if (data.specList && data.specList.length) {
    //               let specType = data.specList[0].specType
    //               if (specType === 1) {
    //                 for (let i = 0; i < speinfo.childList.length; i++) {
    //                   let item = speinfo.childList[i]
    //                   if (item.isDefault !== 1) {
    //                     showList.push(item)
    //                   } else {
    //                     showList.push(item)
    //                     break
    //                   }
    //                 }
    //                 if (showList && showList.length) {
    //                   for (let i = 0; i < showList.length; i++) {
    //                     let item = showList[i]
    //                     if (i === 0) {
    //                       if (showList.length > 1) {
    //                         specification = item.qty + item.unit
    //                       } else if (showList.length === 1) {
    //                         specification = item.qty + item.unit + '/' + item.packageUnit
    //                       }
    //                     } else if (i < showList.length - 1) {
    //                       specification += '*' + item.qty + item.unit
    //                     } else if (i === showList.length - 1) {
    //                       specification += '*' + item.qty + item.unit + '/' + item.packageUnit
    //                     }
    //                   }
    //                   unit = showList[showList.length - 1].packageUnit
    //                   price = showList[showList.length - 1].salePrice
    //                 }
    //               } else if (specType === 2) {
    //                 specification = data.specList[0].childList[0].packageUnit || ''
    //                 price = data.specList[0].childList[0].salePrice || ''
    //               }
    //             }
    //           }
    //           let priceshow = price ? parseFloat(price) : 0
    //
    //           //单个商品..
    //           this.resetDatalist()
    //           if (this.iteminfo.config.datalist && this.iteminfo.config.datalist.length) {
    //             let datalistItem = this.iteminfo.config.datalist[0]
    //             datalistItem.id = data.id
    //             datalistItem.name = data.name
    //             datalistItem.price = priceshow.toFixed(2)
    //             datalistItem.unit = unit
    //             if (data.coverList && data.coverList.length > 0) {
    //               for (let i = 0; i < data.coverList.length; i++) {
    //                 let coverListItem = data.coverList[i]
    //                 if (coverListItem && coverListItem.type === 1 && coverListItem.imgUrl) {    //图片类型
    //                   datalistItem.imgUrl = coverListItem.imgUrl
    //                   break
    //                 } else if (coverListItem && coverListItem.type === 2 && coverListItem.videoUrl) {//视频类型
    //                   datalistItem.imgUrl = coverListItem.videoUrl + '?x-oss-process=video/snapshot,t_1000,f_png,w_0,h_0'
    //                   break
    //                 }
    //               }
    //             }
    //           }
    //
    //           // this.dataList = [{
    //           //   code: data.code,
    //           //   documentId: data.documentId,
    //           //   categoryName: data.categoryName || '',
    //           //   groupName: data.groupName || '',
    //           //   name: data.name || '',
    //           //   userName: data.userName || '',
    //           //   createTime: data.createTime ? new Date(data.createTime).format('yyyy-MM-dd') : '',
    //           //   unit: unit,
    //           //   price: priceshow.toFixed(2) || '',
    //           //   specification: specification
    //           // }]
    //         }
    //       })
    //     } else {
    //       this.iteminfo.config.datalist = this.getDefaultProductList()
    //     }
    //   } else {
    //     // this.iteminfo.config.datalist = this.getDefaultProductList()
    //     this.resetDatalist()
    //   }
    // },

    /**
     * 清空datalist 每个item的数据
     */
    // resetDatalist () {
    //   let datalist = this.iteminfo.config.datalist
    //   if (datalist) {
    //     datalist.forEach(item => {
    //       item.id = 0
    //       item.name = ''
    //       item.imgUrl = ''
    //       item.price = ''
    //       item.unit = ''
    //     })
    //   }
    // },

    ...mapActions([
      'getGoods',
      'getGoodDetail',
    ])
  }
}
</script>

<style lang="scss" scoped>
.lin2 {
  color: #333;
  font-size: 13px;
  line-height: 20px;
  height: 40px;
  margin-top: 6px;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box; /** 对象作为伸缩盒子模型显示 **/
  -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
  -webkit-line-clamp: 2; /** 显示的行数 **/
  overflow: hidden; /** 隐藏超出的内容 **/
}

.modal-product-link ::v-deep {
  .ivu-modal-body {
    padding: 0;
    display: flex;
    justify-content: center;
  }

  //标题下横线
  .ivu-modal-header {
    border-bottom: none;
  }

  //确认取消按钮上面红线
  .ivu-modal-footer {
    border-top: none;
  }
}

//扩大商品链接按钮点击范围
.icon-link {
  padding: 7px;
  margin: 0;
}

//扩大商品链接按钮点击范围
#input-product ::v-deep {
  .ivu-input-group-append {
    padding: 0;
  }
}

</style>